<div class="page-content">
  <div class="content-box">

```
<img src="assets/logo-solusoft.jpg" alt="SoluSoft SPA" class="logo" />

<h1>Quiénes Somos</h1>

<p class="intro">
  En <strong>Soluprime</strong> somos una empresa orientada al desarrollo de soluciones tecnológicas para la gestión empresarial.
  Nuestro principal objetivo es crear herramientas simples, confiables y eficientes que ayuden a personas, emprendedores,
  empresas y oficinas contables a optimizar sus procesos y mejorar la toma de decisiones.
</p>

<p class="intro">
  Actualmente nos encontramos desarrollando nuestro <strong>ERP Contable Soluprime</strong>, una plataforma moderna diseñada para
  apoyar la administración contable y financiera de pequeñas y medianas empresas, incorporando funcionalidades que facilitan
  el control, la organización y el crecimiento de cada negocio.
</p>

<div class="info-grid">

  <div class="info-card">
    <h3>Nuestra Misión</h3>
    <p>
      Desarrollar soluciones tecnológicas innovadoras y fáciles de utilizar, que permitan a nuestros clientes optimizar sus
      procesos, mejorar su productividad y contar con información confiable para la gestión de sus organizaciones.
    </p>
  </div>

  <div class="info-card">
    <h3>Nuestra Visión</h3>
    <p>
      Consolidarnos como una empresa referente en soluciones de gestión empresarial y sistemas contables, reconocida por la
      calidad de nuestros productos, la cercanía con nuestros clientes y nuestro compromiso con la mejora continua.
    </p>
  </div>

</div>
```

  </div>
</div>
